import licensePlateVue from './index.vue'

const install = Vue => {
  if (install.installed) {
    return
  }
  Vue.component(licensePlateVue.name, licensePlateVue)
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

licensePlateVue.install = install

export default licensePlateVue
export { licensePlateVue }
